import { findBiggestContainerDiscount } from "../findBiggestContainerDiscount/index.js";
import type { SupplierRetailerConnectionDiscountItemType } from "../supplierRetailerConnectionDiscountCommons.js";

export const calculateBiggestContainerDiscountPrice = ({
  connectionDiscounts,
  product,
}: {
  connectionDiscounts: {
    deletedAt: Date | null;
    discountAmount: number;
    type: "flat" | "percentage";
    itemType: SupplierRetailerConnectionDiscountItemType | null;
  }[];
  product: {
    containerType: string | null;
    productPriceTier: {
      price: number;
    };
  };
}) => {
  const biggestContainerDiscount = findBiggestContainerDiscount({
    connectionDiscounts,
    product,
  });

  if (!biggestContainerDiscount) {
    return product.productPriceTier.price ?? 0;
  }

  const discountedPrice =
    product.productPriceTier.price -
    biggestContainerDiscount.productItemDiscountAmount;

  return discountedPrice < 0 ? 0 : discountedPrice;
};
